const state = {
  showroomList: []
}
export default state
